// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"ContactData__ContactData__Wtsjg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/ContactData/ContactData.css
// module id = 240
// module chunks = 1